export const mixpanelScriptSrc = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
